import { useQuery } from '@tanstack/react-query'
import { client } from '../client'
import { queryKeys } from '../keys'
import type { components } from '@/lib/generated/api-types'

// Type exports
export type SnowHuntStatus = components['schemas']['SnowHuntStatus']
export type SnowHuntParams = components['schemas']['SnowHuntParams']
export type SnowHuntAccountConfig =
  components['schemas']['SnowHuntAccountConfig']
export type SnowHuntAccountMetrics =
  components['schemas']['SnowHuntAccountMetrics']
export type SnowHuntBookingInfo = components['schemas']['SnowHuntBookingInfo']
export type SnowHuntOptimizationInfo =
  components['schemas']['SnowHuntOptimizationInfo']

// Get snow hunt status with automatic polling while active
export function useSnowHuntStatus(
  primaryAccount: string | undefined,
  enabled = false,
) {
  return useQuery({
    queryKey: queryKeys.snowHunt.current(primaryAccount!),
    queryFn: async () => {
      const { data, error } = await client.GET('/api/v1/snow-hunt/current', {
        params: { query: { primary_account: primaryAccount! } },
      })
      if (error) throw error
      return data
    },
    enabled: !!primaryAccount && enabled,
    staleTime: 0,
    refetchInterval: (query) => {
      const status = query.state.data?.status
      if (status === 'searching' || status === 'optimizing') {
        return 1000 // 1 second polling
      }
      return false
    },
  })
}
